import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import RightPanel from '../dashboard/RightPanel';
import HomePage from '../../pages/HomePage';
import GameGallery from '../admincomponents/dashboards/GameGallery';
import SmartQuizSetup from '../smartquiz/SmartQuizSetup';
import GeoGuessSetup from '../geoguess/GeoGuessSetup';
import SketcherSetup from '../sketcher/SketcherSetup';
import GameDetail from '../gamedetail/GameDetail';
import GameLobby from '../gamelobby/GameLobby';
import './DashboardLayout.css';

const DashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="dash-layout">
      {/* Overlay for mobile sidebar */}
      {sidebarOpen && (
        <div
          className="dash-layout__overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div
        className={`dash-layout__sidebar ${sidebarOpen ? 'dash-layout__sidebar--open' : ''}`}
      >
        <Sidebar onNavClick={() => setSidebarOpen(false)} />
      </div>

      <div className="dash-layout__center">
        <TopBar onMenuToggle={() => setSidebarOpen((s) => !s)} />
        <main className="dash-layout__main">
          <Routes>
            <Route
              path="/"
              element={<Navigate to="/dashboard/home" replace />}
            />
            <Route path="home" element={<HomePage />} />
            <Route path="games" element={<GameGallery />} />
            <Route path="games/smart" element={<SmartQuizSetup />} />
            <Route path="games/geo" element={<GeoGuessSetup />} />
            <Route path="games/sketcher" element={<SketcherSetup />} />
            <Route path="games/game/:gameId" element={<GameDetail />} />
            <Route path="games/game/:gameId/lobby" element={<GameLobby />} />
            <Route path="*" element={<div style={{ textAlign: 'center', padding: '3rem' }}><h2>🚀 Coming Soon</h2><p style={{ color: 'var(--color-text-secondary)' }}>This feature is under development.</p></div>} />
          </Routes>
        </main>
      </div>

      <div className="dash-layout__right">
        <RightPanel />
      </div>
    </div>
  );
};

export default DashboardLayout;
